// @flow

import * as React from 'react';
import { ResponsiveImage, type Source as ResponsiveImageSource } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';

import styles from './Photo.less';

type Props = {|
  photo?: ResponsiveImageSource[],
  length: number,
  placeholder?: string,
|};

const Photo = ({ photo, length, placeholder = 'suitcase-fill' }: Props) => (
  <>
    {photo ? (
      <ResponsiveImage sources={photo} width={`${length}px`} height={`${length}px`} />
    ) : (
      <div
        style={{ width: length, height: length, fontSize: Math.round(length * 0.3) }}
        className={styles.placeholder}
      >
        <Icon name={placeholder} className={styles.icon} />
      </div>
    )}
  </>
);

export default Photo;
